import React from 'react'
import PageBody from '../../components/PageBody'

export default function NotFound () {
  return <PageBody title={"Whoops! That page doesn't exist"} fill />
}
